import React from 'react';
import PropTypes from 'prop-types';
import { Badge, BADGE_VARIANTS } from 'afl-design-system';

import { useWindowSize } from 'common/react/hooks/use-window-resize';
import { DsTeamIcon } from 'common/react/components/DsTeamIcon';

/**
 *
 * Desktop is a single row.
 * Below desktop it becomes a column.
 *
 * @param {object} props - Props.
 * @param {Array} props.byes - The teams on a bye this round.
 * @returns {React.ReactElement} The byes card.
 */
export const MatchCardByes = ({ byes }) => {
    const windowSize = useWindowSize();
    const isDesktop = windowSize.width >= PULSE.app.measurements.desktop;

    const layoutClasses = isDesktop
        ? 'min-h-2xl items-center justify-center gap-2xs px-s'
        : 'min-h-96 flex-col items-start justify-between px-xs';

    return (
        <div className="afl-design-system match-card w-full bg-surface-container rounded-sm">
            <div
                className={`flex w-full rounded-sm shadow-1 label-l-semi-bold text-on-surface py-2xs ${layoutClasses}`}
            >
                <Badge size="small" variant={BADGE_VARIANTS.VARIANT.TBC}>
                    {PULSE.I18N.lookup('label.fixtureBar.byes')}
                </Badge>
                <div className="flex flex-wrap items-center gap-2xs">
                    {byes.map((bye) => (
                        <DsTeamIcon
                            key={bye.providerId}
                            className="shrink-0"
                            providerId={bye.providerId}
                            theme="notext"
                            size="large"
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

MatchCardByes.propTypes = {
    byes: PropTypes.array.isRequired
};
